const schema = () => ({
  type: 'object',
  properties: {
    ref_code: {
      title: 'کد پیگیری',
      type: 'string',
    },
    description: {
      title: 'توضیحات',
      type: 'string',
    },
    condition: {
      type: 'boolean',
      title: 'تمام هزینه',
      default: false,
    },
  },
  allOf: [
    {
      if: {
        properties: {
          condition: {
            const: false,
          },
        },
      },
      then: {
        properties: {
          amount: {
            type: 'number',
            title: 'مقدار',
          },
        },
      },
    },
  ],
});

export default schema;
